import React, { useEffect, useState } from "react";
import clinicService from "../../../../services/clinic.service";
import { useEyeconxStore } from "../../../../store/eyeconxStore";
import { toast } from "react-toastify";
import ActivityDebugItem from "./ActivityDebugItem";

const MEDIUM_ICONS = {
  SMS: "bi-chat-text-fill text-primary",
  EMAIL: "bi-envelope-fill text-info",
  CALL: "bi-telephone-fill text-success",
  DEFAULT: "bi-question-circle text-muted"
};

export default function ClinicActivity({ categoryValue = "ALL" }) {
  const clinicId = useEyeconxStore((state) => state.user.clinicId);

  const [loading, setLoading] = useState(false);
  const [activity, setActivity] = useState([]);

  const [page, setPage] = useState(0);
  const [pageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(1);

  // Search Filters
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [preferredName, setPreferredName] = useState("");
  const [date, setDate] = useState("");

  useEffect(() => {
    loadActivity(0);
  }, [categoryValue]);

  const buildQuery = () => {
    let qParts = [];

    if (firstName) qParts.push(`firstName:${firstName}`);
    if (lastName) qParts.push(`lastName:${lastName}`);
    if (preferredName) qParts.push(`preferredName:${preferredName}`);
    if (categoryValue !== "ALL") qParts.push(`category:${categoryValue}`);
    if (date) qParts.push(`date:${date}`);

    return qParts.join(",");
  };

  const loadActivity = async (pageNumber = 0) => {
    try {
      setLoading(true);

      const query = buildQuery();

      const res = await clinicService.getClinicActivity(
        clinicId,
        pageNumber,
        pageSize,
        query
      );

      const data = res.data;

      setActivity(data.content || []);
      setPage(pageNumber);
      setTotalPages(data.totalPages || 1);

    } catch (err) {
      toast.error("Failed to load clinic activity");
    } finally {
      setLoading(false);
    }
  };

  const getIcon = (medium) => {
    return MEDIUM_ICONS[medium] || MEDIUM_ICONS.DEFAULT;
  };

  return (
    <div className="card shadow-sm border-0">
      <div className="card-header bg-white">
        <h5 className="fw-semibold mb-0">
          <i className="bi bi-clipboard-data text-primary me-2"></i>
          Clinic Activity — {categoryValue === "ALL" ? "All" : categoryValue}
        </h5>
      </div>

      {/* Filters */}
      <div className="card-body border-bottom">
        <div className="row gy-2 mt-3">
          <div className="col-md-3">
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </div>

          <div className="col-md-3">
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>

          <div className="col-md-3">
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Preferred Name"
              value={preferredName}
              onChange={(e) => setPreferredName(e.target.value)}
            />
          </div>

          <div className="col-md-3">
            <input
              type="date"
              className="form-control form-control-sm"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
          </div>
        </div>

        <div className="mt-3 text-end">
          <button
            className="btn btn-primary text-white"
            onClick={() => loadActivity(0)}
          >
            <i className="bi bi-search me-1"></i> Search
          </button>
        </div>
      </div>

      {/* Activity List */}
      <div className="card-body p-0">
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary"></div>
          </div>
        ) : activity.length === 0 ? (
          <div className="text-center py-5 text-muted">
            <i className="bi bi-inbox fs-2 opacity-50"></i>
            <p className="mt-2">No activity found</p>
          </div>
        ) : (
          <ul className="list-group list-group-flush">
            {activity.map((a) => (
              <ActivityDebugItem key={a.id} a={a} />
            ))}
          </ul>
        )}
      </div>

      {/* Pagination */}
      {!loading && totalPages > 1 && (
        <div className="card-footer bg-white d-flex justify-content-between">
          <button
            className="btn btn-sm btn-outline-secondary"
            disabled={page === 0}
            onClick={() => loadActivity(page - 1)}
          >
            <i className="bi bi-chevron-left"></i> Previous
          </button>

          <span className="text-muted small">
            Page {page + 1} of {totalPages}
          </span>

          <button
            className="btn btn-sm btn-outline-secondary"
            disabled={page + 1 >= totalPages}
            onClick={() => loadActivity(page + 1)}
          >
            Next <i className="bi bi-chevron-right"></i>
          </button>
        </div>
      )}
    </div>
  );
}
